import LoadingOverlay from 'react-loading-overlay-ts';
import { AboutResearchInterface } from "@/src/models/IAboutResearch";
import { BudgetDataInterface, UsedBudgetInterface } from "@/src/models/IBudgetData";
import { ActivityReportInterface, BudgetReportInterface, ObjectiveReportInterface, ProgressReportPreviewInterface } from "@/src/models/IProgress";
import { OutputFileListInterface, OutputInterface, OutputReportInterface } from "@/src/models/Result";
import { App, Button, Card, DatePicker, Flex, Form, Input, InputNumber, List, Modal, notification, Popover, Progress, Radio, Select, Space, Steps, StepsProps, Table, Upload, UploadProps } from "antd";
import axios from "axios";
import { Editor } from "ckeditor5";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import CkEditor from "../ckeditor/ckEditor";
import { formatNumber, monthcolumn } from "../functionLater";
import { UploadOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import React from "react";

export function CompletionReportCheck(){

    const customDot: StepsProps['progressDot'] = (dot, { status, index }) => (
        <>
          {dot}
        </>
      );

    const [IsStudent,setIsStudent] = useState(false)

    const [progress_id,setprogress_id] = useState(0)

    const [LastStatus,setLastStatus] = useState('')
    const [CurrentReviewer,setCurrentReviewer] = useState('')
    const [CurrentReviewerName,setCurrentReviewerName] = useState('')
    const [LastReviewResult,setLastReviewResult] = useState('')

    const [LastStaffCommentData,setLastStaffCommentData]= useState(moment())
    const [LastDirectorCommentData,setDirectorCommentData]= useState(moment())
    const [ViceChancellorCommentData,setViceChancellorCommentData]= useState(moment())


    const [Note,setNote] = useState('')
    const NoteRef = useRef();
    const [LastReviewSubmittedDate,setLastReviewSubmittedDate] = useState(moment())

    const [SubmitMod,setSubmitMod] = useState(false);
    const [current,setcurrent] = useState(1)
    const [checkdate,setcheckdata] = useState(moment())

    const [SentedData,setSentedData]= useState<ProgressReportPreviewInterface>();
    const [IsCompletionSent,setIsCompletionSent] = useState(false);
    const [IsEdit,setIsEdit] = useState(false)
    

    const [ActivityReport,setActivityReport] = useState<ActivityReportInterface[]>([]);
    const [CompensationBudgetReport,setCompensationBudgetReport] = useState<BudgetReportInterface[]>([]);
    const [OutcomeBudgetReport,setOutcomeBudgetReport] = useState<BudgetReportInterface[]>([]);
    const [ItemExpenseBudgetReport,setItemExpenseBudgetReport] = useState<BudgetReportInterface[]>([]);
    const [ObjectiveReport,setObjectiveReport] = useState<ObjectiveReportInterface[]>([]);
    const [OutputReport,setOutputReport] = useState<OutputReportInterface[]>([]);

    const [isActive,setisActive]= useState(false);
    const [isHistory,setisHistory]= useState(false);

    const [submittedRound,setsubmittedRound] = useState(1)


    const SentResult = [
        {
            ResultMain:'ส่งมอบผลผลิตที่ระบุ และต้นฉบับรายงานการวิจัยจำนวน 2  เล่ม พร้อมแฟลชไดร์ฟ จำนวน 2 อัน ที่สมบูรณ์ และหลักฐานการตีพิมพ์เผยแพร่ผลงานวิจัย  แก่ผู้ให้ทุน ตามเงื่อนไขที่ผู้ให้ทุนกำหนด',
            subdata:[
                {RemainSub:'ตีพิมพ์เผยแพร่ผลงานวิจัยและนวัตกรรมในวารสารระดับนานาชาติ'},
                {RemainSub:'ตีพิมพ์เผยแพร่ผลงานวิจัยและนวัตกรรมในวารสารระดับ TCI กลุ่มที่ 1'},
                {RemainSub:'ตีพิมพ์เผยแพร่ผลงานวิจัยและนวัตกรรมในวารสารระดับ TCI กลุ่มที่ 2'},
            ]
        },{
            ResultMain:'ส่งมอบผลผลิตที่ระบุ และเอกสารหลักฐานการตีพิมพ์เผยแพร่ผลงานวิจัย  จำนวน  1  ชุด  แก่ผู้ให้ทุน ตามเงื่อนไขที่ผู้ให้ทุนกำหนด',
            subdata:[
                {RemainSub:'ตีพิมพ์เผยแพร่ผลงานวิจัยและนวัตกรรมในวารสารระดับนานาชาติ'},
                {RemainSub:'ตีพิมพ์เผยแพร่ผลงานวิจัยและนวัตกรรมในวารสารระดับ TCI กลุ่มที่ 1'},
                {RemainSub:'ตีพิมพ์เผยแพร่ผลงานวิจัยและนวัตกรรมในวารสารระดับ TCI กลุ่มที่ 2'},
            ]
        },{
            ResultMain:'กรณีงานวิจัยหลักสูตร ส่งมอบผลผลิตที่ระบุ และส่งต้นฉบับรายงานการวิจัย จำนวน 1  เล่ม พร้อมแฟลชไดร์ฟ จำนวน 1 อัน ที่สมบูรณ์  แก่ผู้ให้ทุน ตามเงื่อนไขที่ผู้ให้ทุนกำหนด',
        
        },
    ]

    const StudentRequirement = [
        {
            label:'ส่งต้นฉบับโครงงานวิจัยเชิงนวัตกรรมฉบับสมบูรณ์ จำนวน 1 เล่ม พร้อมไฟล์ PDF หรือหลักฐานการยื่นจดทะเบียนทรัพย์สินทางปัญญา ให้แก่ผู้ให้ทุนตามเงื่อนไขที่ผู้ให้ทุนกำหนด',
            value:'ส่งต้นฉบับโครงงานวิจัยเชิงนวัตกรรมฉบับสมบูรณ์ จำนวน 1 เล่ม พร้อมไฟล์ PDF หรือหลักฐานการยื่นจดทะเบียนทรัพย์สินทางปัญญา ให้แก่ผู้ให้ทุนตามเงื่อนไขที่ผู้ให้ทุนกำหนด'
        },{
            label:'ส่งเอกสารหลักฐานการตีพิมพ์เผยแพร่ผลงานวิจัย โดยมีผู้ทรงคุณวุฒิพิจารณา (Peer Review) หรือตีพิมพ์เผยแพร่ผลงานในฐานข้อมูล TCI จำนวน 1 ชุด ให้แก่ผู้ให้ทุนภายใน 2 ปี หลังเสร็จสิ้นโครงการ',
            value:'ส่งเอกสารหลักฐานการตีพิมพ์เผยแพร่ผลงานวิจัย โดยมีผู้ทรงคุณวุฒิพิจารณา (Peer Review) หรือตีพิมพ์เผยแพร่ผลงานในฐานข้อมูล TCI จำนวน 1 ชุด ให้แก่ผู้ให้ทุนภายใน 2 ปี หลังเสร็จสิ้นโครงการ'
        },{
            label:'ส่งเอกสารหลักฐานใบตอบรับการเข้าร่วมนำเสนอผลงานทางวิชาการ อย่างน้อย 1 รายการ ให้แก่ผู้ให้ทุนภายใน 1 ปี หลังเสร็จสิ้นโครงการ',
            value:'ส่งเอกสารหลักฐานใบตอบรับการเข้าร่วมนำเสนอผลงานทางวิชาการ อย่างน้อย 1 รายการ ให้แก่ผู้ให้ทุนภายใน 1 ปี หลังเสร็จสิ้นโครงการ'
        },{
            label:'ส่งเอกสารหลักฐานการเข้าร่วมนำเสนอผลงาน หรือเข้าร่วมการประกวดรายการประกวดระดับชาติ หรือ ในงาน “มหกรรมงานวิจัยแห่งชาติ” ( Thailand Research Expo) ที่จัดโดย สำนักงานการวิจัยแห่งชาติ (วช.) กระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม (อว.) ให้แก่ผู้ให้ทุนภายใน 1 ปี หลังเสร็จสิ้นโครงการ',
            value:'ส่งเอกสารหลักฐานการเข้าร่วมนำเสนอผลงาน หรือเข้าร่วมการประกวดรายการประกวดระดับชาติ หรือ ในงาน “มหกรรมงานวิจัยแห่งชาติ” ( Thailand Research Expo) ที่จัดโดย สำนักงานการวิจัยแห่งชาติ (วช.) กระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม (อว.) ให้แก่ผู้ให้ทุนภายใน 1 ปี หลังเสร็จสิ้นโครงการ'
        },
    ]
    
    const [SelectedResult,setSelectedResult] = useState('')
    const [SelectedSubResult,setSelectedSubResult] = useState('')


    const {ROCKEditors,CKEditors,getHTML} = CkEditor();


    const { project_id } = useParams();

    const [form] = Form.useForm();
    const [BudgetForm]= Form.useForm();


    const watchedCompensationValues = Form.useWatch('compensation', BudgetForm);
    const [UsedCompensationsumHis,setUsedCompensationsumHis] = useState(0)
    const UsedCompensationsum = React.useMemo(() => {
        if (!watchedCompensationValues) return UsedCompensationsumHis;
      
        const total = watchedCompensationValues.reduce(
          (sum: number, item: any) => sum + Number(item?.sum || 0),
          0
        );
      
        return total === 0 ? UsedCompensationsumHis : total;
      }, [watchedCompensationValues, UsedCompensationsumHis]);
    


    const watchedOutcomeValues = Form.useWatch('outcome', BudgetForm);
    const [UsedOutcomesumHis,setUsedOutcomesumHis] = useState(0)
    const UsedOutcomesum = React.useMemo(() => {
        if (!watchedOutcomeValues) return UsedOutcomesumHis;
      
        const total = watchedOutcomeValues.reduce(
          (sum: number, item: any) => sum + Number(item?.sum || 0),
          0
        );
      
        return total === 0 ? UsedOutcomesumHis : total;
      }, [watchedOutcomeValues, UsedOutcomesumHis]);
   



    const watchedItemexpenseValues = Form.useWatch('itemexpense', BudgetForm);
    const [UsedItemexpensesumHis,setUsedItemexpensesumHis] = useState(0)
    const UsedItemsum = React.useMemo(() => {
        if (!watchedItemexpenseValues) return UsedItemexpensesumHis;
      
        const total = watchedItemexpenseValues.reduce(
          (sum: number, item: any) => sum + Number(item?.sum || 0),
          0
        );
      
        return total === 0 ? UsedItemexpensesumHis : total;
      }, [watchedItemexpenseValues, UsedItemexpensesumHis]);


      const [Output,setOutput] = useState<OutputInterface[]>([])
      const [OutputProgress,setOutputProgress] = useState<OutputReportInterface[]>([])
      const [OutputFileList,setOutputFileList] = useState<OutputFileListInterface[]>([])

      const [OutputMod,setOutputMod] = useState(false);
      const [OutputTopic,setOutputTopic]= useState('');

    const [previewUrl, setPreviewUrl] = useState<string | null>(null);


    const [selectedmonth,setselectedmonth] = useState(99)
    const [endmonth,setEndMonth] = useState(99)
    const [selectedyear,setselectedyear] = useState(9999)

    const [DataFirst,setDataFirst] = useState<AboutResearchInterface[]>([]);

    const [compensationsum,setCompensationSum] = useState(0)
    const [compensationMonetry,setCompensationMonetrySum] = useState(0)
    const [compensationPrepared,setCompensationPreparedSum] = useState(0)
    const [compensationIndirect,setCompensationIndirectSum] = useState(0)
    const [compensationUsedBudget,setCompensationUsedBudget] = useState<UsedBudgetInterface[]>([]);

    
    const [outcomesum,setOutcomeSum] = useState(0)
    const [outcomeMonetry,setOutcomeMonetrySum] = useState(0)
    const [outcomePrepared,setOutcomePreparedSum] = useState(0)
    const [outcomeIndirect,setOutcomeIndirectSum] = useState(0)
    const [OutcomeUsedBudget,setOutcomeUsedBudget] = useState<UsedBudgetInterface[]>([]);


    const [itemsum,setItemnSum] = useState(0)
    const [itemMonetry,setItemMonetrySum] = useState(0)
    const [itemPrepared,setItemPreparedSum] = useState(0)
    const [itemIndirect,setItemIndirectSum] = useState(0)
    const [itemUsedBudget,setitemUsedBudget] = useState<UsedBudgetInterface[]>([]);


    const [compensationItems, setCompensationItems] = useState<BudgetDataInterface[]>([]);
    const [OutcomeItems, setOutcomeItems] = useState<BudgetDataInterface[]>([]);

    const {message} = App.useApp();
    
    const [Keys, setExpandedRowKeys] = useState<number[]>([]);

  
    const [ItemCost, setItemCost] = useState<BudgetDataInterface[]>([]);

    const [ProgressSummary,setProgressSummary] = useState("")
    const [ProblemsAndObstacle,setProblemsAndObstacle] = useState("")
    const [Suggestion,setSuggestion] = useState("")
    const [FuturePlan,setFuturePlan] = useState("")


    const ProgressSummaryRef = useRef<Editor | null>(null);
    const ProblemsAndObstacleRef = useRef<Editor | null>(null);
    const SuggestionRef = useRef<Editor | null>(null);

    const BudgetTypeCol = [
        {
          id: 1,
          detail: 'หมวดค่าตอบแทน',
          category:'compensation',
          sum:compensationsum,
          Usedsum:UsedCompensationsum,
          MonetrySum:compensationMonetry,
          PreparedSum:compensationPrepared,
          IndirectSum:compensationIndirect
        },
        {
          id: 2,
          detail: 'หมวดค่าใช้จ่าย',
          category:'outcome',
          sum:outcomesum,
          Usedsum:UsedOutcomesum,
          MonetrySum:outcomeMonetry,
          PreparedSum:outcomePrepared,
          IndirectSum:outcomeIndirect
        },
        {
            id: 3,
            detail: 'หมวดค่าวัสดุ และอุปกรณ์',
            category:'itemexpense',
            sum:itemsum,
            Usedsum:UsedItemsum,
            MonetrySum:itemMonetry,
            PreparedSum:itemPrepared,
            IndirectSum:itemIndirect
          },
          {
            id: 4,
            detail: 'รวม',
            category:'',
            sum:Number(itemsum)+Number(outcomesum)+Number(compensationsum),
            Usedsum:UsedCompensationsum + UsedOutcomesum + UsedItemsum,
            MonetrySum:Number(compensationMonetry)+Number(outcomeMonetry)+Number(itemMonetry),
            PreparedSum:Number(compensationPrepared)+Number(outcomePrepared)+Number(itemPrepared),
            IndirectSum:Number(compensationIndirect)+Number(outcomeIndirect)+Number(itemIndirect)
          }
      ];
      const handleExpand = (expanded: boolean, record: any) => {
        
        if (expanded) {
            console.log(record.id)
            setExpandedRowKeys([record.id]); // Expand only the clicked row
        } else {
            setExpandedRowKeys([]); // Collapse all rows
        }
    };

    const props: UploadProps = {
        name: 'file',
        accept: ".pdf",
        action: `${process.env.REACT_APP_BASE}/UploadOutput/${project_id}`,
        headers: {
          authorization: 'authorization-text',
        },
        onChange(info) {
          if (info.file.status !== 'uploading') {
            console.log(info.file, info.fileList);
          }
          if (info.file.status === 'done') {
            notification.success({message:`${info.file.name} file uploaded successfully`});
          } else if (info.file.status === 'error') {
            notification.error({message:`${info.file.name} file upload failed.`});
          }
        },
      };

      const getFilelist = async(Output:any) =>{
        const data = {
            Output : Output
        }
        axios.post(`${process.env.REACT_APP_BASE}/getOutputFileList/${project_id}/${submittedRound}`,data).then((response)=>{
            if(response.status==200){
                setOutputFileList(response.data)
                setOutputTopic(Output)
                setOutputMod(true)
            }
        })
    }

    const viewFile = async(Output:any,FileID:number)=>{
        const data = {
            Output:Output,
        }
        await axios.post(`${process.env.REACT_APP_BASE}/GetOutputFile/${FileID}`,data,
        { responseType: 'blob' }).then(response=>{
            if (response.status === 200) {

                const blob = response.data; 
                const blobUrl = URL.createObjectURL(blob);
    
                setPreviewUrl(blobUrl); 
            }
        })

    }

    const DeleteFile = async(Output:any,FileID:number) =>{
        axios.delete(`${process.env.REACT_APP_BASE}/DelOutputFile/${FileID}/${project_id}/${submittedRound}`).then(response=>{
            if(response.status==200){
                getFilelist(Output)
                setPreviewUrl(null)
                notification.success({message:'ลบไฟล์สำเร็จ'})
            }
        })
    }
    
    const handleProgressSummaryEditorChange = () =>{
        setProgressSummary(getHTML(ProgressSummaryRef))
    }
   
    const handleProblemsAndObstacleEditorChange = () =>{
        setProblemsAndObstacle(getHTML(ProblemsAndObstacleRef))
    }
    const handleSuggestionEditorChange = () =>{
        setSuggestion(getHTML(SuggestionRef))
    }
    
    const expandedRowRender = (tempdata: any) => {
        let dataSource: any[] = [];

      const category = tempdata.category

      if (tempdata.category === 'compensation') {
        dataSource = compensationUsedBudget;
      } else if (tempdata.category === 'outcome') {
        dataSource = OutcomeUsedBudget;
      } else if (tempdata.category === 'itemexpense') {
        dataSource = itemUsedBudget;
      }
    
      return <>
      <Form form={BudgetForm}>
        <Table
            columns={[
                {
                    title: '',
                    width: 37,
                    dataIndex: 'id',
                    key: 'id',
                    render: (_, record) => (
                    <Flex justify="center">
                        <p> </p>
                    </Flex>
                    ),
                },
                {
                    title:'',
                    dataIndex: 'BudgetDetail',
                    key: 'BudgetDetail',
                    width: 450,
                    render: (_, record,index) => (
                        <>
                            <p>{record.BudgetDetail} </p>
                            {typeof dataSource[index]?.note === 'string' && (
                                <p style={{ color: 'gray' }}>{dataSource[index].note}</p>
                            )}
                        </>
                        ),
                },
                {
                    title:'',
                    dataIndex: 'Budget',
                    key: 'Budget',
                    width: 250,
                    render: (_, record) => (
                    <Flex justify="center">{formatNumber(record.Budget)}</Flex>
                    ),},
                {
                    title:'',
                    dataIndex: 'BudgetDetail',
                    key: 'BudgetDetail',
                    width: 250,
                    render: (_, record,index) => (
                        <>
                            <Form.Item name={[category , index,'sum']}>
                                <Input
                                    type="number"
                                        />
                            </Form.Item>
                        </>
                    ),
                },
                {title:'หมายเหตุ',
                    render: (_, record,index) => (
                        <>
                            <Form.Item 
                            name={[category , index,'note']}
                            >
                                <Input 
                                onChange={(value)=>
                                    {
                                        let tmpdata = dataSource || []
                                        tmpdata[index].note = value
                                        if (record.category === 'compensation') {
                                            setCompensationUsedBudget(tmpdata);
                                        } else if (record.category === 'outcome') {
                                            setOutcomeUsedBudget(tmpdata);
                                        } else if (record.category === 'itemexpense') {
                                            setitemUsedBudget(tmpdata);
                                        }
                                    }
                                }/>
                            </Form.Item>
                        </>
                    ),}
            ]}
            showHeader={false} 
            pagination={false}
            dataSource={dataSource}/>
        </Form>
      </>
    }

    const sentdata = async()=>{
        const ReportData = form.getFieldsValue();

        let TMPActivity = JSON.parse(DataFirst[0].activity)

        let x = TMPActivity
        x.forEach((item: { ActivityRatio: any; }, index: string | number) => {
            item.ActivityRatio = ReportData.ActivityInfo?.[index]?.ProgressionPercent || '';
        });
        x.forEach((item: { note: any; }, index: string | number) => {
            item.note = ReportData.ActivityInfo?.[index]?.note || '';
        });

        let y = TMPActivity


        y.forEach((item: { SixMonthProgress: any; }, index: string | number)=>{
            item.SixMonthProgress = ReportData.Obj?.[index]?.PastProgress|| ''
        })
        y.forEach((item: { SixMonthPlan: any; }, index: string | number)=>{
            item.SixMonthPlan = ReportData.Obj?.[index]?.FuturePlan|| ''
        })

       let tmpOut = OutputProgress
       tmpOut.forEach((item, index: string | number)=>{
        item.SentYear= ReportData.Output?.[index]?.SentYear;
        item.RealOutput= ReportData.Output?.[index]?.RealOutput;
        item.Progresspercentage= ReportData.Output?.[index]?.Progresspercentage;
        item.Attachment= ReportData.Output?.[index]?.Attachment;
       })
       console.log(tmpOut)

       const FundData = BudgetForm.getFieldsValue();

       let compensationUsedBudgetFundTmpData = compensationUsedBudget
       compensationUsedBudgetFundTmpData.forEach((item, index)=>{
        item.Spent = parseInt(FundData.compensation?.[index]?.sum)
        item.note = FundData.compensation?.[index]?.note
        || ''
        })
        let OutcomeUsedBudgetFundTmpData = OutcomeUsedBudget
        OutcomeUsedBudgetFundTmpData.forEach((item, index)=>{
        item.Spent = parseInt(FundData.outcome?.[index]?.sum)
        item.note = FundData.outcome?.[index]?.note
        || ''
        })
        let ItemUsedBudgetFundTmpData = itemUsedBudget
        ItemUsedBudgetFundTmpData.forEach((item, index)=>{
        item.Spent = parseInt(FundData.itemexpense?.[index]?.sum)
        item.note = FundData.itemexpense?.[index]?.note
        || ''
        })
        const BackData = {
            editOrSubmitted:IsEdit,
            projectStatus:LastStatus,
            round:submittedRound,
            ActivityProgress:x,
            Objective:y,
            ProcessResult:ProgressSummary,
            ProblemAndObstacle:ProblemsAndObstacle,
            SuggestionAndExtraInfo:Suggestion,
            FundHistory:{
                compensation : compensationUsedBudgetFundTmpData,
                outcome : OutcomeUsedBudgetFundTmpData,
                item : ItemUsedBudgetFundTmpData
            },
            ProgressPlan:FuturePlan,
            output:tmpOut,
            CompletionPassingMeasure:SelectedResult,
            SubCompletionPassingMeasure:SelectedSubResult
        }

        axios.post (`${process.env.REACT_APP_BASE}/SentCompletion/${project_id}`,BackData).then(response=>{
            if(response.status==200){
                window.location.reload();
            }
        })

    }

      const getData = async() =>{
            await axios.get(`${process.env.REACT_APP_BASE}/BudgetReqInfo/${project_id}/${sessionStorage.getItem('user')}`).then(response=>{
                setDataFirst(response.data.main)

                if(response.data.main[0].period){
                    const dataperiod = JSON.parse(response.data.main[0].period)
                    const datamonth = dataperiod[0].split('-')
                    const datamonth2 = dataperiod[1].split('-')
                    setselectedmonth(Number(datamonth[1]))
                    setEndMonth(Number(datamonth2[1]))
                    setselectedyear(Number(datamonth[0]))
                }

                if(response.data.main[0].budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'){
                    setIsStudent(true)
                  }
    

                if(response.data.compensation.length!=0||response.data.outcome.length!=0||response.data.itemexpense.length!=0){
                    setCompensationItems(response.data.compensation)
                    setCompensationUsedBudget(response.data.compensation)
                    const totalCompensation = response.data.compensation.reduce((sum: any, item: any) => sum + item.Budget, 0);
                    setCompensationSum(totalCompensation)
                    const totalMonetryCompensationBudget = response.data.compensation
                        .filter((item:any) => item.BudgetType === "ตัวเงิน(เบิกจ่าย)")
                        .reduce((sum:any, item:any) => sum + item.Budget, 0);
                    setCompensationMonetrySum(totalMonetryCompensationBudget)
                    const totalPreparedCompensationBudget = response.data.compensation
                        .filter((item:any) => item.BudgetType === "ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้")
                        .reduce((sum:any, item:any) => sum + item.Budget, 0);
                    setCompensationPreparedSum(totalPreparedCompensationBudget)
                    const totalIndirectCompensationBudget = response.data.compensation
                        .filter((item:any) => item.BudgetType === "ไม่เป็นตัวเงิน(งบอ้อม)")
                        .reduce((sum:any, item:any) => sum + item.Budget, 0);
                    setCompensationIndirectSum(totalIndirectCompensationBudget)
                
                    const totalOutcome = response.data.outcome.reduce((sum: any, item: any) => sum + item.Budget, 0);
                    setOutcomeSum(totalOutcome)
                    setOutcomeItems(response.data.outcome)
                    setOutcomeUsedBudget(response.data.outcome)
                    const totalMonetryOutcomeBudget = response.data.outcome
                    .filter((item:any) => item.BudgetType === "ตัวเงิน(เบิกจ่าย)")
                    .reduce((sum:any, item:any) => sum + item.Budget, 0);
                    setOutcomeMonetrySum(totalMonetryOutcomeBudget)
                    const totalPreparedOutcomeBudget = response.data.outcome
                    .filter((item:any) => item.BudgetType === "ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้")
                    .reduce((sum:any, item:any) => sum + item.Budget, 0);
                    setOutcomePreparedSum(totalPreparedOutcomeBudget)
                    const totalIndirectdOutcomeBudget = response.data.outcome
                    .filter((item:any) => item.BudgetType === "ไม่เป็นตัวเงิน(งบอ้อม)")
                    .reduce((sum:any, item:any) => sum + item.Budget, 0);
                    setOutcomeIndirectSum(totalIndirectdOutcomeBudget)

                    const totalItem = response.data.itemexpense.reduce((sum: any, item: any) => sum + item.Budget, 0);
                    setItemnSum(totalItem)
                    setItemCost(response.data.itemexpense)
                    setitemUsedBudget(response.data.itemexpense)
                    const totalMonetryItemBudget = response.data.itemexpense
                    .filter((item:any) => item.BudgetType === "ตัวเงิน(เบิกจ่าย)")
                    .reduce((sum:any, item:any) => sum + item.Budget, 0);
                    setItemMonetrySum(totalMonetryItemBudget)
                    const totalPreparedItemeBudget = response.data.itemexpense
                    .filter((item:any) => item.BudgetType === "ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้")
                    .reduce((sum:any, item:any) => sum + item.Budget, 0);
                    setItemPreparedSum(totalPreparedItemeBudget)
                    const itemMonetrySum = response.data.itemexpense
                    .filter((item:any) => item.BudgetType === "ไม่เป็นตัวเงิน(งบอ้อม)")
                    .reduce((sum:any, item:any) => sum + item.Budget, 0);
                    setItemIndirectSum(itemMonetrySum)
                    
                }

                if(response.data.main[0].output&&response.data.main[0].outcome&&response.data.main[0].impacts){
                    setOutput(JSON.parse(response.data.main[0].output))
                    setOutputProgress(JSON.parse(response.data.main[0].output))
                }
                
            })
      }

      const CheckLastOrEdit = async() =>{
            await axios.get(`${process.env.REACT_APP_BASE}/GetLastReportID/${project_id}`).then(async response=>{
                if(response.status==200){
                    console.log(response.data)
                    setprogress_id(response.data.ProgressReportID)

                    if(response.data.SentOrder){
                        setsubmittedRound(response.data.SentOrder+1)
                        
                    }
                    if(response.data.ProgressReportID){
                        await axios.get(`${process.env.REACT_APP_BASE}/getReportReview/${response.data.ProgressReportID}`).then(resp=>{
                            if(resp.status==200){
                                console.log(resp.data)
                                if(resp.data.lastComment){
                                    setNote(resp.data.lastComment.note)
                                    setCurrentReviewer(resp.data.lastComment.ReviewerPosition)
                                    setCurrentReviewerName(resp.data.lastComment.ReviewerName)
                                    setLastReviewResult(resp.data.lastComment.ApprovedStatus)
                                    setLastReviewSubmittedDate(moment(resp.data.lastComment.SummittedDate))}

                                if(resp.data.lastStaffComment){
                                    setLastStaffCommentData(moment(resp.data.lastStaffComment.SummittedDate))
                                }

                                if(resp.data.lastDirectorComment){
                                    setDirectorCommentData(moment(resp.data.lastDirectorComment.SummittedDate))
                                }

                                if(resp.data.lastViceChancellorComment){
                                    setViceChancellorCommentData(moment(resp.data.lastViceChancellorComment.SummittedDate))
                                }
                            }
                        })
                    }

                    if(response.data.ReportStatus){
                        setLastStatus(response.data.ReportStatus)
                        if(response.data.ReportStatus=='ยื่นต่อผู้อำนวยการสำนักวิจัย'){
                            setcurrent(2)
                        }else if(response.data.ReportStatus=='สั่งแก้ไขจากผู้อำนวยการสำนักวิจัย'){
                            setcurrent(2)
                            setExpandedRowKeys([1, 2, 3]);
                            setCurrentReviewer('ผู้อำนวยการสำนักวิจัย')
                        }else if(response.data.ReportStatus=='สั่งแก้ไขจากรองอธิการบดีสำนักฝ่ายวิจัยฯ'
                            ||response.data.ReportStatus=='รอการพิจารณาจากรองอธิการบดีสำนักฝ่ายวิจัยฯ'){
                            setcurrent(3)
                            setExpandedRowKeys([1, 2, 3]);
                            setCurrentReviewer('รองอธิการบดีสำนักฝ่ายวิจัยฯ')
                        }
                        switch(response.data.ReportStatus){
                            case 'รอการพิจารณาจากเจ้าหน้าที่วิจัย':
                                setcurrent(1)
                                break;
                            case 'สั่งแก้ไขจากเจ้าหน้าที่สำนักวิจัย':
                                setExpandedRowKeys([1, 2, 3]);
                                setcurrent(1)
                                break;
                            case 'รอการพิจารณาจากผู้อำนวยการสำนักวิจัย':
                            case 'สั่งแก้ไขจากผู้อำนวยการสำนักวิจัย':
                                setcurrent(2)
                                break;
                            case 'อนุมัติ':
                                setcurrent(3)
                                break;
                        }

                        
                    }
                    if(response.data.IsCompletion=='TRUE'){
                        setIsCompletionSent(true)
                        setcheckdata(response.data.SentBy)
                    }

                    if(response.data.ReportStatus=="สั่งแก้ไขจากเจ้าหน้าที่สำนักวิจัย"||
                        response.data.ReportStatus=="สั่งแก้ไขจากผู้อำนวยการสำนักวิจัย"||
                        response.data.ReportStatus=="สั่งแก้ไขจากรองอธิการบดีสำนักฝ่ายวิจัยฯ"
                    ){
                        setIsEdit(true)
                        GetReport(response.data.ProgressReportID)
                        await axios.get(`${process.env.REACT_APP_BASE}/getReportReview/${response.data.ProgressReportID}`).then(resp=>{
                            if(resp.status==200){
                                console.log(resp.data)
                                setNote(resp.data.note)
                            }
                        })
                    }
                    
                }
            })
      }

      const GetReport = async(progress_id:any)=>{
        await axios.get(`${process.env.REACT_APP_BASE}/GetProgressData/${progress_id}/${sessionStorage.getItem('user')}`).then(async response=>{
            if(response.status==200){
                setSentedData(response.data.main[0])
                setActivityReport(response.data.activity)
                setCompensationBudgetReport(response.data.compensationbudget)
                setOutcomeBudgetReport(response.data.outcomebudget)
                setItemExpenseBudgetReport(response.data.itemexpensebudget)
                setObjectiveReport(response.data.obj)
                setProgressSummary(response.data.main[0].ProgressionSummary)
                setProblemsAndObstacle(response.data.main[0].ProblemAndObstacle)
                setSuggestion(response.data.main[0].SuggestionAndInformation)
                setOutputReport(response.data.output)
                setSelectedResult(response.data.main[0].CompletionPassingMeasure)
                setSelectedSubResult(response.data.main[0].SubCompletionPassingMeasure)
                console.log(response.data.activity)

                form.setFieldsValue({
                    ActivityInfo:response.data.activity.map((item: { note: any; ActivityRatio:any;  })=>({
                        ProgressionPercent:item.ActivityRatio,
                        note:item.note
                    })),
                    Obj: response.data.obj.map((item: { SixMonthProgress: any; }) => ({
                        PastProgress: item.SixMonthProgress || ''
                      })),
                    Output:response.data.output.map((item: {
                        [x: string]: any; Progresspercentage: any; 
})=>({
                        SentYear:moment.utc(item.SentYear),
                        Progresspercentage:item.Progresspercentage,
                        RealOutput:item.RealOutput,
                        Attachment:item.Attachment
                    }))
                })

                setUsedCompensationsumHis(
                    response.data.compensationbudget.reduce(
                        (sum: number, item: { Spent: any; }) => sum + Number(item.Spent || 0),
                        0
                      )
                )
                setUsedOutcomesumHis(
                    response.data.outcomebudget.reduce(
                        (sum: number, item: { Spent: any; }) => sum + Number(item.Spent || 0),
                        0
                      ))
                setUsedItemexpensesumHis(
                    response.data.itemexpensebudget.reduce(
                        (sum: number, item: { Spent: any; }) => sum + Number(item.Spent || 0),
                        0
                      ))

                BudgetForm.setFieldsValue(
                    {
                        compensation:
                            response.data.compensationbudget.map((item: { Spent: any; note: any; })=>({
                                sum:item.Spent,
                                note:item.note,
                            }))
                        ,
                        outcome: response.data.outcomebudget.map((item: { Spent: any; note: any; })=>({
                                sum:item.Spent,
                                note:item.note,
                            })),
                        itemexpense: response.data.itemexpensebudget.map((item: { Spent: any; note: any; })=>({
                                sum:item.Spent,
                                note:item.note,
                            })),
                    }

                )
            }
            })
        }



    useEffect(() =>{
      CheckLastOrEdit();
      getData();
      
      },[])
      
    return (
    <>

        {
            IsCompletionSent&&<>
                {
                    IsEdit&&<>
                        <h1 className="text-3xl font-semibold leading-relaxed">แก้ไขการยื่นปิดโครงการ</h1>
                    </>||
                    <> 
                        <h1 className="text-3xl font-semibold leading-relaxed">ตรวจสอบสถานะการยื่นปิดโครงการ</h1>
                        {LastStatus=='อนุมัติ'&&
                        <>
                            <Flex justify='center'>
                                <Progress type="circle" percent={100} />
                            </Flex>
                            <br/>

                            <Flex justify='center'>
                                <p>โครงการของท่านได้รับการอนุมัติให้ปิดโครงการได้แล้ว</p>
                            </Flex>
                            <br/>
                            <Flex justify='center'>
                                <Button type='primary' href={`${process.env.REACT_APP_BASE}/exportProgressRep/${progress_id}/${sessionStorage.getItem('user')}`}>ดาวน์โหลดไฟล์</Button>
                            </Flex>
                            <br/>
                        </>}
                        
                    </>
                }
            </>||<>
                <h1 className="text-3xl font-semibold leading-relaxed">ยื่นคำขอปิดโครงการ</h1>
            </>
        }


       
        <hr/>
        <br/>
        {
            IsCompletionSent&&
                <>{IsEdit
                    &&
                    <Card>
                        <p>โครงการของท่านมีการสั่งแก้ไขจาก{CurrentReviewer}โดยมีคำชี้แจ้งดังนี้</p>
                        <Card>
                            <ROCKEditors
                                myRef={NoteRef}
                                htmlBox={Note}
                                />
                        </Card>
                    </Card>
                    ||
                <>
                        <Steps
                        current={current}
                        progressDot={customDot}
                        items={[
                            {
                                title: 'ยื่นผลการรายงาน',
                                description:<p>ยื่นผลการรายงานแล้ว</p>,
                            },
                            {
                                title: <>{LastStatus=='รอการพิจารณาจากเจ้าหน้าที่วิจัย'&&
                                    <h2>เจ้าหน้าที่สำนักวิจัยฯกำลังตรวจ</h2>||
                                    <h2>เจ้าหน้าที่สำนักวิจัยฯอนุมัติคำขอแล้ว</h2>
                                    }</>,
                                description:(current==1&&<p>คำขอของท่านกำลังอยู่ในขั้นตอนนี้</p>||
                                    (current>1)&&<p>เจ้าหน้าที่สำนักวัจัยได้อนุมัติคำขอนี้เมื่อ {moment.utc(LastStaffCommentData).format('DD MMMM YYYY ')}</p>),
                            },
                            {
                                title: <>{LastStatus=='รอการพิจารณาจากผู้อำนวยการสำนักวิจัย'&&
                                    <h2>กำลังตรวจสอบโดยผู้อำนวยการสำนักวิจัยฯ</h2>||
                                    <h2>ผู้อำนวยการสำนักวิจัยฯอนุมัติคำขอแล้ว</h2>
                                    }</>,
                                description:(current==2&&<p>คำขอของท่านกำลังอยู่ในขั้นตอนนี้</p>||
                                    (current>2)&&<p>ผู้อำนวยการสำนักวิจัยฯได้อนุมัติคำขอนี้แล้วเมื่อ {moment.utc(LastDirectorCommentData).format('DD MMMM YYYY ')}</p>
                                    ||<p>ยังดำเนินการไม่ถึงขั้นตอนนี้</p>),
                            },
                            {
                                title: <>{LastStatus=='รอการพิจารณาจากผู้อำนวยการสำนักวิจัยฯ'&&
                                    <h2>กำลังตรวจสอบโดยรองอธิการบดีสำนักฝ่ายวิจัยฯฯ</h2>||
                                    <h2>รองอธิการบดีสำนักฝ่ายวิจัยฯฯอนุมัติคำขอแล้ว</h2>
                                    }</>,
                                description:(current==2&&<p>คำขอของท่านกำลังอยู่ในขั้นตอนนี้</p>||
                                    (current>2)&&<p style={{color:'gray'}}>รองอธิการบดีได้อนุมัติคำขอนี้แล้วเมื่อ {moment.utc(ViceChancellorCommentData).format('DD MMMM YYYY ')}</p>
                                    ||<p>ยังดำเนินการไม่ถึงขั้นตอนนี้</p>),
                            },
                        ]}
                    />
                    {CurrentReviewer!=''&&
                    <><p className="text-2xl font-semibold leading-relaxed">ผลการตรวจสอบล่าสุด</p>
                        <br/>
                        {CurrentReviewerName&&
                            <Card style={{marginLeft:'5vw'}}>
                            <p><span style={{fontWeight:'bold'}}>ผู้ตรวจสอบ</span> : {CurrentReviewerName}</p>
                            <p><span style={{fontWeight:'bold'}}>สถานะผู้ตรวจสอบ</span> : {CurrentReviewer}</p>
                            <p><span style={{fontWeight:'bold'}}>ผลการตรวจสอบ</span> : {LastReviewResult}</p>
                            <p><span style={{fontWeight:'bold'}}>บันทึกข้อความ :</span> </p>
                                <ROCKEditors
                                    myRef={NoteRef}
                                    htmlBox={Note}
                                    />
                            <p><span style={{fontWeight:'bold'}}>วันเวลาที่ยื่นรายงาน :</span>&nbsp;{moment.utc(LastReviewSubmittedDate).format("DD MMMM YYYY hh:mm:ss")}</p>
                            </Card>}
                        </>
                    ||
                        <>
                            <p className="text-2xl font-semibold leading-relaxed">ผลการตรวจสอบล่าสุด</p>
                            <Card style={{marginLeft:'5vw'}}>
                                <h1>ยังไม่มีผลการตรวจสอบ</h1>
                                
                            </Card>
                        </>}
                </>}</>
        }

{
         (!IsCompletionSent||IsEdit)&&
         <>
            <Form
                   form={form}
                   autoComplete="off"
                   layout='vertical'>
               {
                   isHistory&&
                   <>
                        <h2 className="text-2xl font-bold leading-relaxed"  style={{display: "flex"}} >ประวัติการส่งผลการปิดโครงการ</h2>
                           <Card style={{marginLeft:'5vw'}}>
                               <p className="font-semibold leading-relaxed" style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>ประวัติการยื่นรายงานครั้งที่&nbsp;&nbsp;<Select style={{width:'10vw'}}/></p>
                               <p></p>
                           </Card>
                           <br/>
                   </>
               }
               <h2 className="text-2xl font-bold leading-relaxed"  style={{display: "flex"}} >ฟอร์มการยื่นขอปิดโครงการ</h2>
                <br/>
                    <Card>
                        <h2  className="text-2xl font-bold leading-relaxed"  style={{display: "flex"}}><u>คำเตือน</u></h2>
                        <p style={{color:'red',marginLeft:'5vw'}}>หากคุณต้องการยื่นปิดโครงการ ความสำเร็จในฟอร์มทุกส่วนควรเป็น 100 เปอร์เซ็น</p>
                        <p style={{marginLeft:'5vw'}}>ขณะนี้คุณได้ยื่นโครงการไปแล้วทั้งหมด {submittedRound-1} ครั้ง</p>
                    </Card>
                <br/>

                   <p className="font-bold leading-relaxed" >รายงานผลการดำเนินการวิจัย และการวิเคราะห์ผลการวิจัย</p>
                       <Table
                           columns={[
                               {
                                   title:'แผนการดำเนินงาน',
                                   dataIndex:'ActivityName',
                                   fixed: 'left',  
                                   width: 200,  
                                   className: 'fixed-column'
                               },
                               {
                                 title:'ระยะเวลาที่ทำกิจกรรม',
                                children:monthcolumn(selectedmonth,endmonth,DataFirst?.[0]?.period? JSON.parse(DataFirst?.[0]?.period): [])

                               },
                              {
                                   title:'ความสำเร็จต่อโครงการ',
                                   dataIndex:'ActivityRatio',
                                   fixed: 'right',  
                                   width: 200, 
                                   className: 'fixed-column',
                                   render: (_, record,index) => (
                                       <>
                                           <Form.Item name={['ActivityInfo', index,'ProgressionPercent']}>
                                               <InputNumber  defaultValue={100} max={100} suffix='%'/>
                                           </Form.Item>
                                       </>
                                   )
                               },{
                                   title:'หมายเหตุ',
                                   fixed: 'right',  
                                   width: 200, 
                                   className: 'fixed-column',
                                   render: (_, record,index) => (
                                       <>
                                           <Form.Item name={['ActivityInfo', index,'note']}>
                                               <TextArea autoSize={{ minRows: 3, maxRows: 5 }}/>
                                           </Form.Item>
                                       </>
                                   )
                               },
                           ]}
                           dataSource={DataFirst?.[0]?.activity ? JSON.parse(DataFirst[0].activity) : []}
                           scroll={{ x: 'max-content' }}
                           pagination={false}
                       />

                    {!IsStudent&&<>
                        <p className="font-bold leading-relaxed" >รายละเอียดของขั้นตอนการดำเนินงานจริงตามแผนงาน (ช่วงรายงานผล) </p>
                       <Table
                           columns={[
                               {
                                   title:'วัตถุประสงค์', 
                                   dataIndex:'ActivityName',
                                   width:'20vw'
                               },
                               {
                                   title:'สิ่งที่ดำเนินการ',
                                   render: (_, record,index) => (
                                       <>

                                           <Form.Item name={['Obj', index,'PastProgress']}>
                                               <TextArea  placeholder='กรอกข้อมูลที่นี่' autoSize={{ minRows: 3, maxRows: 5 }}/>
                                           </Form.Item>
                                       </>
                                   )
                               },
                              
                               
                           ]}
                           pagination={false}
                           dataSource={DataFirst?.[0]?.activity ? JSON.parse(DataFirst[0].activity) : []}
                        />
                   <p className="font-semibold">สรุปผลการดำเนินงาน</p>
                   <CKEditors
                        myRef={ProgressSummaryRef}
                        htmlBox={ProgressSummary}
                        onBlur={handleProgressSummaryEditorChange}
                        toolstate={true}
                        />
                   <Form.Item label={<p className="font-semibold">ปัญหาและอุปสรรค</p>}>
                    <CKEditors
                        myRef={ProblemsAndObstacleRef}
                        htmlBox={ProblemsAndObstacle}
                        onBlur={handleProblemsAndObstacleEditorChange}
                        toolstate={true}/>
                   </Form.Item>
                   <Form.Item label={<p className="font-semibold">คำแนะนำและข้อมูลเพิ่มเติมอื่นๆ (ถ้ามี) </p>}>
                        <CKEditors
                            myRef={SuggestionRef}
                            htmlBox={Suggestion}
                            onBlur={handleSuggestionEditorChange}
                            toolstate={true}/>
                   </Form.Item>
                   <p className="font-semibold">รายจ่ายที่เกิดขึ้นจริง รอบ 6 เดือน</p>
                       <Table
                           rowKey="id"
                           columns={[
                               {
                                   title:'หมวดรายการงบประมาณ',
                                   dataIndex:'detail',
                                   width: 450,
                               },
                               {
                                   title:'งบประมาณ (บาท)',
                                   width: 500,
                                   children:[
                                       {
                                           title:'งบประมาณที่ได้รับ',
                                           width: 250,
                                           render: (_, record) => (
                                             <Flex justify="center">{formatNumber(record.MonetrySum+record.PreparedSum+record.IndirectSum)}</Flex>
                                           ),},
                                       {
                                           title:'จำนวนเงินที่ใช้ไป',
                                           width: 250,
                                           render: (_, record) => (
                                             <>
                                               <Flex justify="center">
                                                    <p>{IsEdit&&<>{formatNumber(record.Usedsum)}</>||<>{formatNumber(record.Usedsum)}</>}</p>
                                                </Flex>
                                             </>
                                       )},
                                   ]
                               },
                               {title:'หมายเหตุ'},
                           ]}
                           expandable={{
                               expandedRowRender,
                               expandedRowKeys: Keys,
                               onExpand: handleExpand,
                               rowExpandable: (record) => {
                                   if (record.category === 'compensation') return compensationItems.length > 0;
                                   if (record.category === 'outcome') return OutcomeItems.length > 0;
                                   if (record.category === 'itemexpense') return ItemCost.length > 0;
                                   return false;
                                 },
                           }}
                           scroll={{ x: 'max-content' }}
                           dataSource={BudgetTypeCol}
                           pagination={false}
                           />
                        </>}
               
                   <p className="font-semibold">ผลผลิตที่คาดว่าจะได้รับ</p>
                   <Table
                       columns={[
                           {
                               title:'ผลผลิต',
                               dataIndex:'Output_name',
                               fixed: 'left',  
                               width: 200,  
                               className: 'fixed-column'
                           },{
                               title: 'จำนวนนำส่ง/หน่วยนับ',
                               dataIndex:'Output_amount',
                               key: 'Output_amount',
                               render: (_, record) => (
                                   <>
                                       <p>{record.Output_amount} {record.Output_unit}</p>
                                   </>
                                 ),
                           },{
                               title:'รายละเอียดผลผลิต',
                                dataIndex:'Output_description'
                           },{
                               title:'ปีที่นำส่งผลผลิต',
                               render: (_, record,index) => (
                                   <>
                                       <Form.Item name={['Output',index,'SentYear']}>
                                           <DatePicker picker="year" placeholder=''/>
                                       </Form.Item>
                                   </>
                                 ),
                           },{
                               title:'เปอร์เซ็นความก้าวหน้าการดำเนินงาน',
                               render: (_, record,index) => (
                                   <>
                                       <Flex justify='center'>
                                            <Form.Item name={['Output',index,'Progresspercentage']}>
                                                <InputNumber
                                                    defaultValue={100}
                                                    suffix='%'/>
                                            </Form.Item>
                                        </Flex>
                                   </>
                                 ),
                           },{
                               title:'ผลผลิตที่เกิดขึ้นจริง',
                               render: (_, record,index) => (
                                   <>
                                       <Form.Item name={['Output',index,'RealOutput']}>
                                           <TextArea defaultValue={OutputReport[index]?.RealOutput} placeholder='กรอกข้อมูลที่นี่' autoSize={{ maxRows: 5 }}/>
                                       </Form.Item>
                                   </>
                                 ),
                           },{
                               title:'หลักฐาน/เอกสารประกอบ',
                               render: (_, record,index) => (
                                   <>
                                       <Form.Item name={['Output',index,'Attachment']}>
                                           <TextArea defaultValue={OutputReport[index]?.Attachment} placeholder='กรอกข้อมูลที่นี่' autoSize={{ maxRows: 5 }}/>
                                       </Form.Item>
                                   </>
                                 ),
                             
                           },{
                               title:'ไฟล์แนบ',
                               width: 200,
                               render: (_, record) => (
                                   <>
                                       <Flex justify='center'>
                                           <Upload {...props}
                                            data={(file)=>({
                                                Output_name: record.Output_name,
                                                filename: file.name,
                                                ProgressReportID:submittedRound
                                            })}>
                                               <Button icon={<UploadOutlined />}>อัพโหลดไฟล์</Button>
                                           </Upload>
                                       </Flex>
                                       <br/>
                                       <Flex justify='center'>
                                           <Button  onClick={()=>{
                                               getFilelist(record.Output_name)
                                            }}>ดูข้อมูลไฟล์ที่ดาวน์โหลด</Button>
                                       </Flex>
                                   </>
                                 ), 
                           }
                       ]}
                       pagination={false}
                       scroll={{ x: 'max-content' }}
                       dataSource={Output}/>

                    

                    <Modal
                    title={`รายชื่อไฟล์ที่เพิ่มเข้ามาในระบบ : ${OutputTopic}`}
                    open={OutputMod}
                    onCancel={()=>{
                        setOutputMod(false)
                        setPreviewUrl(null)
                    }}
                    footer={<></>}>
                    <hr/>
                    <List
                    bordered
                    renderItem={(item, index) =>(
                        <><List.Item
                            actions={[
                                <> 
                                    <a onClick={()=>viewFile(item.Output,item.FileID)}
                                    style={{ color: 'blue', textDecoration: 'none', cursor: 'pointer' }}
                                    onMouseEnter={(e) => (e.currentTarget.style.color = '#1890ff')}
                                    onMouseLeave={(e) => (e.currentTarget.style.color = 'blue')}>
                                        ดูไฟล์</a>&nbsp;| &nbsp;
                                    <a onClick={()=>DeleteFile(item.Output,item.FileID)}
                                        style={{ color: 'blue', textDecoration: 'none', cursor: 'pointer' }}
                                        onMouseEnter={(e) => (e.currentTarget.style.color = '#1890ff')}
                                        onMouseLeave={(e) => (e.currentTarget.style.color = 'blue')}>
                                            ลบไฟล์</a>
                                </>
                             ]}>
                            <List.Item.Meta
                                title={<p>{item.Filename}</p>}
                            />
                        </List.Item>
                            <br/>
                        
                        </>
                    )}
                    dataSource={OutputFileList}/>
                    {previewUrl&&<>
                        <iframe src={previewUrl} 
                         width="100%"
                         height="600px"
                         title="PDF Viewer"/>
                    </>}
                    </Modal>
                   <Form.Item label={<p style={{fontWeight:'bold'}}>เมื่อผู้รับทุนทำการวิจัยเสร็จสมบูรณ์ตามระยะเวลาที่กำหนด ผู้รับทุนสามารถปิดโครงการวิจัยได้ 3 กรณี ดังนี้ (หากมีตัวเลือกย่อยปรากฎ ขอให้ท่านเลือกหัวข้อย่อยด้วย)</p>}>
                   {!IsStudent&&
                        <Space direction="vertical">
                            <Radio.Group  className='font-normal' onChange={(e) => setSelectedResult(e.target.value)} value={SelectedResult}>
                            <Space direction="vertical">
                                {SentResult.map((item)=>(
                                    <React.Fragment key={item.ResultMain}>
                                        <Space direction="vertical">
                                            <Radio value={item.ResultMain}>{item.ResultMain}</Radio>
                                            {(SelectedResult == item.ResultMain && SelectedResult != 'กรณีงานวิจัยหลักสูตร ส่งมอบผลผลิตที่ระบุ และส่งต้นฉบับรายงานการวิจัย จำนวน 1 เล่ม พร้อมแฟลชไดร์ฟ จำนวน 1 อัน ที่สมบูรณ์ แก่ผู้ให้ทุน ตามเงื่อนไขที่ผู้ให้ทุนกำหนด') && (
                                                <>
                                                    <>
                                                    <Radio.Group onChange={(e) => setSelectedSubResult(e.target.value)} style={{ marginLeft: '40px' }} value={SelectedSubResult}> 
                                                    <Space direction="vertical">
                                                        {
                                                            item.subdata?.map((subtype)=>(
                                                            <>
                                                                <Radio key={subtype.RemainSub} value={subtype.RemainSub}>{subtype.RemainSub}</Radio>
                                                            </>)
                                                        )
                                                        }
                                                    </Space>
                                                    </Radio.Group>
                                                    </>
                                                    
                                                </>
                                            )}
                                        </Space>
                                    </React.Fragment>
                                ))}
                            </Space>
                            </Radio.Group>
                        </Space>
                    || <Space direction="vertical">
                    <Radio.Group  className='font-normal' onChange={(e) => setSelectedResult(e.target.value)} value={SelectedResult}>
                    <Space direction="vertical">
                        {StudentRequirement.map((item)=>(
                            <Radio value={item.value}>{item.label}</Radio>
                        ))}
                    </Space>
                    </Radio.Group>
                </Space>}
                   </Form.Item>
                   {IsStudent&&<>
                    <p className="font-semibold">ไฟล์หลักฐานเพื่อปิดโครงการ</p>
                    <Flex justify='center'>
                        <Upload {...props}
                        data={(file)=>({
                            Output_name: 'อื่นๆ',
                            filename: file.name,
                            ProgressReportID:submittedRound
                        })}>
                            <Button icon={<UploadOutlined />}>อัพโหลดไฟล์หลักฐานปิดโครงการ</Button>
                        </Upload>
                    </Flex>
                    <br/>
                    <Flex justify='center'>
                        <Button  onClick={()=>{
                            getFilelist('อื่นๆ')
                        }}>ดูข้อมูลไฟล์ที่ดาวน์โหลด</Button>
                    </Flex>
                    <br/>
                    <hr/>
                    <br/>
                    </>}
                   <Flex justify='center'>
                       <Button onClick={()=>setSubmitMod(true)}>ยื่นคำขอปิดโครงการ</Button>
                   </Flex>
                   <Modal
                   centered
                    open={SubmitMod}
                    title="ยืนยันการยื่นโครงการ"
                    footer={<></>}
                    onCancel={()=>{
                        setSubmitMod(false)
                    }}>
                        <p>คุณต้องการยืนยันยื่นผลการแก้ไขรายงานหรือไม่</p>
                        <Flex justify='flex-end'>
                            <Button type='primary' danger onClick={()=>setSubmitMod(false)}>ยกเลิก</Button>&nbsp;
                            <Button type='primary' onClick={()=>sentdata()}>ยืนยัน</Button>
                        </Flex>
                   </Modal>
               </Form>
         </>
       }
       
    </>)
}